'use strict'
const Component = require('./component/Popover')
const Aspect = require('./aspect/PopoverAspect')

module.exports = {
    Component,
    Aspect
}